import { creatorQueryKeys as e } from "./useCreatorQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { creatorApi as r } from "@maat/api-main";
//#region src/creator/useCreateCreatorLinkMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.createLink(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.overview() });
		}
	});
};
//#endregion
export { i as useCreateCreatorLinkMutation };
